import React, { useState } from "react";
import BgShape from "../images/faq/homeimg.jpg";
import BgShape2 from "../images/faq/homeimg2.jpg";
import BgShape3 from "../images/faq/homeimg3.jpg";
import BgShape4 from "../images/faq/homeimg4.jpg";
import BgShape5 from "../images/faq/homeimg5.jpg";
import BgShape6 from "../images/faq/homeimg6.jpg";
import BgShape7 from "../images/faq/homeimg7.jpg";
import BgShape8 from "../images/faq/homeimg8.jpg";
import BgShape9 from "../images/faq/homeimg9.jpg";
import BgShape10 from "../images/faq/homeimg10.jpg";
import BgShape11 from "../images/faq/homeimg11.jpg";
import BgShape12 from "../images/faq/homeimg12.jpg";
import BgShape13 from "../images/faq/homeimg13.jpg";
import BgShape14 from "../images/faq/homeimg14.jpg";

function Atvbanner2() {
  const images = [
    { src: BgShape },
    { src: BgShape2 },
    { src: BgShape3 },
    { src: BgShape4 },
    { src: BgShape5 },
    { src: BgShape6 },
    { src: BgShape7 },
    { src: BgShape8 },
    { src: BgShape9 },
    { src: BgShape10 },
    { src: BgShape11 },
    { src: BgShape12 },
    { src: BgShape13 },
    { src: BgShape14 },
  ];

  const [selectedImage, setSelectedImage] = useState(null);
 
   const openImage = (url) => {
     setSelectedImage(url);
   };
 
   const closeImage = () => {
     setSelectedImage(null);
   };



 
   return (
     <>
       <section id='celebzi'
         className="banner-section"
         style={{
         //  backgroundColor: "#9f5e37",
         //  backgroundImage: "linear-gradient(285deg, #9f5e37 0%, #3d281a 100%)", width:'100%'
         backgroundColor: 'rgba(0, 0, 0, 0.59)', width:'100%'
         }}
       >
         <div className="row" style={{width:'100%'}}  >
         
           <div className="col-12">
             <div className="container">
               <div className="banner-content" >
                 <div className="banner-content__text" style={{width:'100%'}}>
                   <h2 style={{textAlign:'center', fontSize:'3.5rem'}}>Celebrity Meetup Gallery</h2>
                 </div>
               </div>
             </div>
           </div>
 
           <div className="col-12" >
           
 
           <div>
       <div style={{ display: 'flex', flexWrap: 'wrap', alignContent:'center', justifyContent:'center' }}>
         {images.map((image, index) => (
           <div key={index} style={{ width: '33%', padding: '5px' }}>
             <img src={image.src} alt={'Image ' + index} style={{ width: '100%', aspectRatio: '16/9', cursor: 'pointer' }} onClick={() => openImage(image.src)} />
           </div>
         ))}
       </div>
       {selectedImage && (
         <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0, 0, 0, 0.7)', display: 'flex', justifyContent: 'center', alignItems: 'center',  zIndex: '2000'  }} onClick={closeImage}>
           <div style={{position:'absolute', color:'white' ,backgroundColor:'red', fontSize: '1.4em', marginBottom:'35%', marginRight:'75%', padding:'8px', borderRadius:'40px', fontWeight:'bold',   }}>Close</div>
           <img src={selectedImage} alt="Selected Image" style={{ maxWidth: '100%', maxHeight: '90%', objectFit: 'contain'  }} />
         </div>
       )}
     </div>
           </div>
         </div>
       </section>
     </>
   );
 }

export default Atvbanner2;